<div class="modal-body p-3 p-md-4">

  <div class="d-flex align-items-center justify-content-between mb-3">
    <div class="d-flex align-items-center overflow-hidden">
      <coach-student-avatar class="me-3" [name]="studentName" [levelKey]="levelKey"></coach-student-avatar>
      <div class="overflow-hidden">
        <p class="fs-normal fw-800 color-gray-950 mb-0 text-truncate">{{'students.plan_meeting'|translate}}</p>
        <p class="fs-small fw-400 color-gray-400 mb-0 text-truncate">{{studentName}}</p>
      </div>
    </div>

    <a class="close-btn clickable ms-2" (click)="modal.dismiss()" [ngbTooltip]="'buttons.close'|translate" container="body"><i class="bi bi-x-lg"></i></a>
  </div>

  <p class="fs-xsmall fw-800 color-gray-500 mb-2">
    <i class="bi bi-calendar-event me-1"></i>{{'students.pick_date'|translate|uppercase}}
  </p>

  <!-- Arrows instead of a scrollbar; the strip itself stays swipeable on touch. -->
  <div class="d-flex align-items-center mb-3">
    <a class="strip-arrow clickable me-2" [class.disabled]="isLoading || atStripStart" (click)="scrollDays(-1)">
      <i class="bi bi-chevron-left"></i>
    </a>

    <div class="day-scroll d-flex flex-grow-1" #dayStrip (scroll)="onStripScroll()">
      <ng-container *ngIf="!isLoading; else daySkeleton">
        <a class="day-option text-center p-2 me-2 clickable" *ngFor="let day of days"
           [class.active]="selectedDay && day.date.isSame(selectedDay, 'day')"
           [class.disabled]="!day.slotCount"
           (click)="selectDay(day.date)">
          <p class="fs-xsmall fw-500 color-gray-400 mb-0">{{day.weekday}}</p>
          <p class="fs-normal fw-800 color-gray-950 mb-0">{{day.dayNumber}}</p>
        </a>
      </ng-container>

      <ng-template #daySkeleton>
        <ngx-skeleton-loader
          count="6" appearance="line"
          [theme]="{'border-radius': '12px', width: '64px', height: '56px', margin: '0 8px 0 0'}"/>
      </ng-template>
    </div>

    <a class="strip-arrow clickable ms-2" [class.disabled]="isLoading || atStripEnd" (click)="scrollDays(1)">
      <i class="bi bi-chevron-right"></i>
    </a>
  </div>

  <p class="fs-xsmall fw-800 color-gray-500 mb-2">
    <i class="bi bi-clock me-1"></i>{{'students.pick_time'|translate|uppercase}}
  </p>

  <p class="fs-small fw-400 color-gray-400" *ngIf="!isLoading && !slotsOfSelectedDay().length">
    {{'students.no_slot'|translate}}
  </p>

  <!-- Placeholders keep the dialog the same height while the slots are loading. -->
  <div class="row g-2" *ngIf="isLoading">
    <div class="col-4" *ngFor="let item of skeletonSlots">
      <ngx-skeleton-loader
        count="1" appearance="line"
        [theme]="{'border-radius': '999px', width: '100%', height: '38px', margin: '0'}"/>
    </div>
  </div>

  <div class="row g-2" *ngIf="!isLoading">
    <div class="col-4" *ngFor="let slot of slotsOfSelectedDay()">
      <a class="slot-option d-block text-center fs-small fw-500 p-2 clickable"
         [class.active]="slot.start === selectedStart" (click)="selectSlot(slot)">
        {{slot.start|date:'HH:mm'}}
      </a>
    </div>
  </div>

  <div class="form-errors mt-2" *ngIf="errKey">
    <p>{{errKey|translate}}</p>
  </div>

  <app-gray-button
    class="d-block mt-3"
    color="primary" [weight]="800" padding="p-2" customClass="fs-normal"
    preIcon="calendar"
    [isLoading]="isSaving" [disabled]="!selectedStart || isSaving"
    [text]="'students.plan_meeting_submit'|translate" (click)="onSubmit()"></app-gray-button>

</div>
